var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.formData.title,
            visible: _vm.drawer,
            direction: _vm.direction,
            modal: true,
            "wrapper-closable": false,
            "before-close": _vm.handleClose,
            "append-to-body": true,
            size: _vm.formData.width,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "invoice" },
            [
              _c(
                "el-form",
                { ref: "form", attrs: { "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择方式：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.type,
                            callback: function ($$v) {
                              _vm.type = $$v
                            },
                            expression: "type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("按人员"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("按部门"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "el-input--small",
                      attrs: { label: "领用对象：" },
                    },
                    [
                      _vm.type == 0
                        ? _c("select-member", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "only-one": true,
                              value: _vm.userList || [],
                            },
                            on: { getSelectList: _vm.getSelectList },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == 1
                        ? _c("select-department", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "only-one": true,
                              value: _vm.frames || [],
                            },
                            on: { changeMastart: _vm.changeMastart },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-box" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        "row-key": "id",
                        "default-expand-all": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "id", label: "序号", "min-width": "45" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.$index + 1))]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "物资名称",
                          "min-width": "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      size: "small",
                                      filterable: "",
                                      placeholder: "请选择物资",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleName(
                                          $event,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.name,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "name", $$v)
                                      },
                                      expression: "scope.row.name",
                                    },
                                  },
                                  _vm._l(
                                    _vm.formData.selectData,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          value: index,
                                          label:
                                            item.name +
                                            " 规格型号: " +
                                            item.units +
                                            (_vm.formData.type === 1
                                              ? " 物资编号: " + item.number
                                              : ""),
                                          disabled:
                                            _vm.ids.includes(item.id) &&
                                            _vm.formData.type === 1,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _vm.formData.type === 1
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "number",
                              label: "物资编号",
                              "min-width": "150",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "units",
                          label: "规格型号",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cate.cate_name",
                          label: "物资分类",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "specs",
                          label: "计量单位",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _vm.formData.type === 0
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "stock",
                              label: "库存数量",
                              "min-width": "80",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.type === 0
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "number",
                              label: "领用数量",
                              "min-width": "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input-number", {
                                        attrs: {
                                          "controls-position": "right",
                                          precision: 0,
                                          size: "small",
                                          min: 1,
                                          max: scope.row.stock,
                                        },
                                        model: {
                                          value: scope.row.sNumber,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "sNumber", $$v)
                                          },
                                          expression: "scope.row.sNumber",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2398511534
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "", "min-width": "40" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("i", {
                                  staticClass:
                                    "el-icon-remove color-tab pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(scope.$index)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt14" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-plus" },
                      on: {
                        click: function ($event) {
                          return _vm.addRow()
                        },
                      },
                    },
                    [_vm._v("添加行")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                { ref: "form", attrs: { "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "el-input--small",
                      attrs: { label: "备 注：" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          "show-word-limit": "",
                          rows: 2,
                          resize: "none",
                          placeholder: _vm.$t("customer.placeholder18"),
                        },
                        model: {
                          value: _vm.mark,
                          callback: function ($$v) {
                            _vm.mark = $$v
                          },
                          expression: "mark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button from-foot-btn fix btn-shadow" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("public.ok")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }